import {
  Grid,
  Box,
  Text,
  Divider,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Flex,
  HStack
} from '@chakra-ui/react'
import { FC } from 'react'
import { TiLockClosed } from 'react-icons/ti'

import {
  ITableGridHeaderColumn,
  ITableHeader
} from '@base/@types/components/Layout/TableGrid'

interface IConfigColumnModal {
  data: ITableHeader[]
  isOpen: boolean
  onOpen?: () => void
  onClose: () => void
  onChange: (index: number, column: number) => void
  isDisabled?: (columnId: string) => boolean
}

const ConfigColumnModal: FC<IConfigColumnModal> = ({
  data,
  isOpen,
  onClose,
  onChange,
  isDisabled
}) => {
  const handleSelectAll = () => {
    data.forEach((group, groupIdx) => {
      if (group.columns) {
        group.columns.forEach((column, columnIdx) => {
          if (!column.show && (!isDisabled || !isDisabled(column.id))) {
            onChange(groupIdx, columnIdx)
          }
        })
      }
    })
  }

  const handleDeselectAll = () => {
    data.forEach((group, groupIdx) => {
      if (group.columns) {
        group.columns.forEach((column, columnIdx) => {
          if (column.show && (!isDisabled || !isDisabled(column.id))) {
            onChange(groupIdx, columnIdx)
          }
        })
      }
    })
  }
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent marginX={4} maxW={400} bgColor="white">
        <ModalHeader
          fontSize={16}
          paddingTop={2}
          paddingBottom={2}
          paddingLeft={4}
          paddingRight={4}
          textColor={'gray.200'}
          background={'#1d5840'}
          borderTopLeftRadius={5}
          borderTopRightRadius={5}
          borderBottom="3px solid #ECC94B"
        >
          Configurar colunas
        </ModalHeader>

        <ModalCloseButton color="white" marginTop={-1} marginRight={-1} />

        <ModalBody
          borderBottomRadius={5}
          paddingX={4}
          paddingBottom={4}
          paddingTop={0}
        >
          <HStack spacing={6} mt={4} mb={3} justifyContent="center">
            <Text
              fontSize="14px"
              fontWeight="600"
              color="green.600"
              cursor="pointer"
              onClick={handleSelectAll}
              _hover={{
                color: 'green.500',
                textDecoration: 'underline'
              }}
            >
              ✓ Selecionar tudo
            </Text>
            <Text
              fontSize="14px"
              fontWeight="600"
              color="red.600"
              cursor="pointer"
              onClick={handleDeselectAll}
              _hover={{
                color: 'red.500',
                textDecoration: 'underline'
              }}
            >
              ✗ Desmarcar tudo
            </Text>
          </HStack>

          <Divider my={2} bgColor="gray.200" />

          {data.map((row: ITableHeader, gpIdx: number) => (
            <Box key={`columns-group-modal-${gpIdx}`} paddingTop={4}>
              <Text fontSize="xs" textTransform="uppercase" color="gray.600">
                {row.group}
              </Text>

              <Divider my={1} bgColor="gray.300" />

              <Grid templateColumns="repeat(2, 1fr)" gap="4px" py={0}>
                {row.columns.map(
                  (column: ITableGridHeaderColumn, columnIdx: number) => (
                    <Flex alignItems="center">
                      {isDisabled(column.id) && (
                        <Box marginRight={1}>
                          <TiLockClosed color="#9f9f9f" />
                        </Box>
                      )}

                      <Checkbox
                        key={`column-modal-${columnIdx}`}
                        isChecked={data[gpIdx].columns[columnIdx].show}
                        onChange={() => onChange(gpIdx, columnIdx)}
                        borderColor="blackAlpha.300"
                        colorScheme="green"
                        isDisabled={isDisabled(column.id)}
                        css={{
                          '.css-7sn7zq[data-checked][data-disabled]': {
                            borderColor: '#dcdcdc',
                            color: 'lightGray'
                          },
                          '.css-7sn7zq[data-disabled]': {
                            border: '2px solid #dcdcdc',
                            color: 'lightGray'
                          }
                        }}
                      >
                        <span style={{ fontSize: '14px', fontWeight: 600 }}>
                          {column.name}
                        </span>
                      </Checkbox>
                    </Flex>
                  )
                )}
              </Grid>
            </Box>
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ConfigColumnModal
